import { Validated } from './Validator';

export default function getInputError<T>(value: Validated<unknown, T>): T | null {
    return (
        value.isValid
            ? null
            : value.error
    );
}
